export default __webpack_public_path__ + "media/edit-w.ac394452.svg";